import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useUserIdentityState } from '@provider/user-identity';
import { getDialoguesKey } from './api.get-dialogues.query.js';
import { updateDialogueRequest } from './api.update-dialogue.request.js';

function useUpdateDialogueMutation() {
  const client = useQueryClient();
  const user = useUserIdentityState(state => state.user);
  return useMutation(updateDialogueMutation(client, user));
}
const updateDialogueMutation = (client, user) => {
  return {
    mutationKey: ["user-area/dialogues/update", user?.id],
    mutationFn: input => updateDialogueRequest(user, input.dialogueId, "message" in input ? input.message : input.plainTextContent),
    onMutate: async input => {
      if (!user || !("message" in input)) {
        return;
      }
      const timestamp = new Date();
      const optimisticDialogueEntry = {
        id: `${input.message}-${timestamp.getTime()}`,
        type: "message",
        author: {
          id: user.id,
          name: user.name,
          team: user.institution?.name,
          role: user.role
        },
        plainTextContent: input.message,
        state: "sent",
        timestamp
      };
      client.setQueryData(getDialoguesKey(user, input.dialogueId), previous => [...(previous ?? []), optimisticDialogueEntry]);
      await client.cancelQueries({
        queryKey: getDialoguesKey(user, input.dialogueId)
      });
      return {
        optimisticDialogueEntry
      };
    },
    onSuccess: (data, input) => {
      if ("message" in input) {
        return;
      }
      client.setQueryData(getDialoguesKey(user, input.dialogueId), previous => previous?.map(it => it.id === input.id ? {
        ...it,
        state: "sent",
        timestamp: new Date()
      } : it));
    },
    onError: (error, input, context) => {
      client.setQueryData(getDialoguesKey(user, input.dialogueId), previous => previous?.map(it => it.id === context?.optimisticDialogueEntry.id ? {
        ...it,
        state: "failed"
      } : it));
    }
  };
};

export { useUpdateDialogueMutation };
//# sourceMappingURL=api.update-dialogue.mutation.js.map
